import { render, staticRenderFns } from "./psychologyRoom.vue?vue&type=template&id=255966e5&"
import script from "./psychologyRoom.vue?vue&type=script&lang=js&"
export * from "./psychologyRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports